export default "__VITE_ASSET__4J$kILZU__"